import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import AccountSection from "./account-section";
import InformationSection from "./information-section";
import DocumentSection from "./document-section";
import { Get } from "../../../apis/api";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import { useSelector } from "react-redux";
import clsx from 'clsx';

const NewCrew = () => {
  const [step, setStep] = useState(1)
  const [data, setData] = useState([])
  const [agentData, setAgentData] = useState([])
  const [userId, setUseID] = useState(null);
  const [loading, setLoading] = useState(false)
  const param = useParams()
  const user = useSelector((state) => state.user.user)
  const { t } = useTranslation()
  const lng = useSelector((state) => state.common.lng)




  useEffect(() => {
    if (param?.id) {
      handleList()
    }
    handleAgentList()
  }, [param.id, step])


  const handleList = () => {
    setLoading(true)
    Get(`${user?.role_key === "super_admin" ? "admin" : "agent/profile"}/crews/${param.id}`).then((res) => {
      setData(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleAgentList = () => {
    setLoading(true)
    Get(`admin/crews/agents`).then((res) => {
      setAgentData(res)
    }).finally(() => {
      setLoading(false)
    })
  }


  const handleStep = () => {
    // eslint-disable-next-line default-case
    switch (step) {
      case 1:
        return (
          <AccountSection onCreate={(id) => setUseID(id)} data={data} agentData={agentData} setStep={setStep}/>
        )
      case 2:
        return (
          <InformationSection userId={userId} data={data} setStep={setStep} />
        )
      case 3:
        return (
          <DocumentSection userId={userId} data={data} />
        )
    }
  }

  return (
    <div className={clsx("mb-10" , lng=='fa' ? '' : 'ltr')}>
      {
        loading && <LoadingFix />
      }
      <div className={"my-container rounded-lg flex justify-between items-center w-full"}>
        <div className={"flex gap-10"}>
          <div onClick={() => setStep(1)} className={`text-gray-700 border-b-2 p-2 ${step === 1 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} font-medium cursor-pointer`}>
            {t("Information")}
          </div>
          <div onClick={() => setStep(2)} className={`text-gray-700 border-b-2 p-2 ${step === 2 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} ${(!userId && data?.length === 0) && "pointer-events-none opacity-25"} font-medium cursor-pointer`}>
            {"Additional Information"}
          </div>
          <div onClick={() => setStep(3)} className={`text-gray-700 border-b-2 p-2 ${step === 3 ? " bg-main/5  border-primary-900 text-primary-900" : " border-transparent  "} ${(!userId && data?.length === 0) && "pointer-events-none opacity-25"} font-medium cursor-pointer`}>
            {"Documents"}
          </div>
        </div>
      </div>
      {
        handleStep()
      }
      <div>

      </div>
    </div>
  );
};

export default NewCrew;
